import { Inject, Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { WINDOW } from '../constants/app-config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(
    private readonly keycloak: KeycloakService,
    @Inject(WINDOW) private readonly window: Window
  ) { }

  persistIdToken(): void {
    try {
      const idToken = this.keycloak.getKeycloakInstance()?.idToken;
      if (idToken) {
        localStorage.setItem('kc_id_token', idToken);
      }
    } catch (error) {
      console.error(error);
    }
  }

  logout(): void {

    try {

      const kcInstance: any = this.keycloak.getKeycloakInstance();
      const stored = localStorage.getItem('kc_id_token');

      if (!kcInstance?.idToken && stored) {
        kcInstance.idToken = stored;
      }
      if (kcInstance?.idToken) {
        this.keycloak.logout(environment.keycloak.logoutUrl);
        return;
      }

    } catch (error) {
      console.error(error);
    }

    this.keycloak.clearToken();
    try { localStorage.removeItem('kc_id_token'); } catch (error) { console.error(error); }
    this.window.location.href = environment.keycloak.logoutUrl;

  }
}
